import Axios from 'axios'

import { SERVER_BASE_URL } from './baseUrl'

export const createMessage = async (token: string, chatId: string, content: string) => {
  try {
    const response = await Axios.post(
      `${SERVER_BASE_URL}api/message`,
      {
        chatId,
        content,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )

    return response.data
  } catch (error) {
    console.error('Erreur lors de la requête :', error)
    throw error
  }
}

export const getMessagesByChat = async (token: string, chatId: string) => {
  try {
    const response = await Axios.get(`${SERVER_BASE_URL}api/message/${chatId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    return response.data
  } catch (error) {
    console.error('Erreur lors de la requête :', error)
    throw error
  }
}

export const updateMessage = async (token: string, messageId: number, content: string) => {
  try {
    const response = await Axios.put(
      `${SERVER_BASE_URL}api/messages/${messageId}`,
      {
        content,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )

    return response.data
  } catch (error) {
    console.error('Erreur lors de la requête :', error)
    throw error
  }
}

export const deleteMessage = async (token: string, messageId: number) => {
  try {
    const response = await Axios.delete(`${SERVER_BASE_URL}api/message/${messageId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    return response.data
  } catch (error) {
    console.error('Erreur lors de la requête :', error)
    throw error
  }
}
